import { render } from "./Leaflet.vue?vue&type=template&id=58b72f04"
import script from "./Leaflet.vue?vue&type=script&lang=js"
export * from "./Leaflet.vue?vue&type=script&lang=js"
script.render = render

export default script